<template>
  <div class="GContainer">
    <div class="filter_container z-flex">
      <div class="filter-select">
        <a-row class="filter" type="flex" justify="end">
          <a-col style="margin-right: 12px">
            <a-select
              ref="select"
              v-model:value="query.surveyShape"
              style="width: 120px"
              :options="tabs"
              @change="handleTabs"
            ></a-select>
          </a-col>
          <a-col style="margin-right: 12px">
            <a-select
              ref="select"
              v-model:value="query.status"
              style="width: 120px"
              :options="selectOptions"
            ></a-select>
          </a-col>
          <a-col>
            <CusButton style="width: 80px" type="primary" @click="listquery(1)">搜索</CusButton>
          </a-col>
        </a-row>
      </div>
    </div>
    <a-table
      :columns="columns"
      :transformCellText="({ text }) => text ?? '--'"
      :pagination="false"
      :data-source="TableData"
      rowKey="id"
      :scroll="{ x: '100%', y: 'calc(100vh - 290px)' }"
    >
      <template #sendName="{ record }">
        <div v-if="record.surveyShape === 1">--</div>
        <div v-else>
          <!-- 发送人 -->
          <roles :solerType="record.sendPersonType" />
          {{ record.sendPersonName }}
        </div>
      </template>
      <template #submit="{ record }">
        <div v-if="record.surveyShape === 0">--</div>
        <div v-else>
          <!-- 提交人 -->
          <roles :solerType="record.submitPersonType" />
          {{ record.submitPersonName }}
        </div>
      </template>
      <template #operation="{ record }">
        <a @click="goDetail(record)">{{ record.surveyShape === 1 ? '查看图片' : '查看详情' }}</a>
      </template>
    </a-table>
    <a-row type="flex" justify="start" style="margin-top: 20px">
      <a-col>
        <a-pagination
          show-size-changer
          show-quick-jumper
          v-model:current="pagination.current"
          v-model:pageSize="pagination.pageSize"
          :total="pagination.total"
          @change="listquery(0)"
          @showSizeChange="listquery(0)"
          :show-total="total => `共${pagination.total}条`"
        />
      </a-col>
    </a-row>
    <Gauge ref="gDetail" :params="detailQuery" />
    <ImageList
      :visible="imgObj.imgVisible"
      title="量表"
      :tips="imgObj.tips"
      :fileList="imgObj.fileList"
      @cancel="handleCancel"
    />
    <!-- 问卷结果iframe -->
    <Info ref="infoRef" :url="scaleResultsUrl"></Info>
  </div>
</template>

<script setup>
import CusButton from '@/components/cus-Button'
import Gauge from './components/gDetail.vue'
import { ref, reactive, computed, onMounted, defineProps } from 'vue'
import { useStore } from 'vuex'
import { GaugeColumns, selectOptions, tabs } from './config'
import { gaugeList } from '@/api/workPlace/gauge.js'
import ImageList from '@/components/ImageList'
import { message } from 'ant-design-vue'
import Info from '../chat/components/ScaleResults/Info.vue'
const props = defineProps({
  ucUserId: {
    type: Number,
    default: null
  },
  mode: {
    type: String,
    default: ''
  }
})
const TableData = ref([])
const initPagination = {
  total: 0,
  current: 1,
  pageSize: 10
}
const pagination = reactive({ ...initPagination })

const detailQuery = reactive({
  surveyId: null,
  surveySendId: null
})
const query = reactive({
  status: null,
  surveyShape: 0
})
const columns = ref([])
const infoRef = ref(null)
const scaleResultsUrl = ref('')
const filterLabel = ['surveyScore', 'sendName', 'sendAt']
const handleColumns = () => {
  const val = query.surveyShape
  if (val === 1) {
    columns.value = GaugeColumns.filter(it => !filterLabel.includes(it.key))
  } else if (val === 0) {
    columns.value = GaugeColumns.filter(it => !['submit'].includes(it.key))
  } else {
    columns.value = GaugeColumns
  }
}
onMounted(() => {
  listquery(1)
})
// 查看量表详情
const gDetail = ref(null)
const goDetail = row => {
  if (row.surveyShape) {
    imageDetail(row)
  } else {
    rowDetail(row)
  }
}
const rowDetail = row => {
  const { surveyId, id, surveyType, url } = row
  if (surveyType !== 1) {
    if (!url) return message.warning('当前量表暂不支持查看！')
    scaleResultsUrl.value = `${url}&mood=readPretty&surveyType=${surveyType}`
    return infoRef.value.showDrawer()
  }
  gDetail.value.gDetailVisible = true
  detailQuery.surveyId = surveyId
  detailQuery.surveySendId = id
}
const imgObj = reactive({
  imgVisible: false,
  fileList: [],
  tips: ''
})
// 查看图片详情
const imageDetail = row => {
  console.log(row)
  const { pictureFileList, writingAt } = row
  imgObj.imgVisible = true
  imgObj.fileList = pictureFileList
  imgObj.tips = `上传时间:${writingAt}`
}
const store = useStore()
const ucPatientId = computed(() => {
  return props?.ucUserId || store?.state?.workOrder?.workOrderGroupInfo?.patientInfo?.ucUserId || ''
})
const listquery = async (reload = 0) => {
  if (reload) {
    Object.assign(pagination, initPagination)
  }
  handleColumns()
  const params = {
    current: pagination.current,
    size: pagination.pageSize,
    patientId: ucPatientId.value,
    ...query
  }
  const { list, totalCount } = await gaugeList(params)
  pagination.total = totalCount
  TableData.value = list
}
// 切换tabs
const handleTabs = key => {
  query.surveyShape = key
  query.status = null
}
// 关闭弹窗
const handleCancel = () => {
  imgObj.imgVisible = false
  imgObj.fileList = []
  imgObj.tips = ''
}
</script>

<style lang="scss" scoped>
.GContainer {
  padding: 25px;
  .filter_container {
    margin-bottom: 20px;
    background: #ffffff;
    border-radius: 4px;
    height: 60px;
    align-items: center;
    padding: 0 20px;
  }
}
</style>
